import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useContest } from '../../../contexts/ContestContext';

// import * as AppPropTypes from '../../../lib/PropTypes';
import styles from '../../../../styles/icons/logos/iga-contest.module.scss';

import blackBubble from '../../../../img/iga/bubble-black.svg';
import whiteBubble from '../../../../img/iga/bubble-white.svg';
import mascot from '../../../../img/iga/mascot@2x.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function IgaContest({ className }) {
    const { ended = false } = useContest();
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <div className={classNames([styles.bubble, styles.blackBubble])}>
                <img className={styles.bubbleImg} src={blackBubble} alt="Black bubble" />
                <div className={styles.bubbleLabelContainer}>
                    <h1 className={styles.bubbleLabel}>
                        <FormattedMessage
                            defaultMessage="Saving{br}Is a Big Yes!"
                            description="IGA Contest title"
                        />
                    </h1>
                </div>
            </div>
            <div className={styles.grandPrize}>
                <div className={styles.mascotContainer}>
                    <img className={styles.mascot} src={mascot} alt="Mascot" />
                </div>
                <div className={styles.content}>
                    <div className={classNames([styles.bubble, styles.whiteBubble])}>
                        <img className={styles.bubbleImg} src={whiteBubble} alt="White bubble" />
                        <div className={styles.bubbleLabelContainer}>
                            <h2 className={styles.bubbleLabel}>
                                <FormattedMessage
                                    defaultMessage="Daily discounts"
                                    description="Grand prize label"
                                />
                            </h2>
                        </div>
                    </div>
                    <h3 className={styles.grandPrizeContent}>
                        <FormattedMessage
                            defaultMessage="and $2,000 worth of groceries to win"
                            description="Grand prize description"
                        />
                    </h3>
                </div>
            </div>
            {ended ? (
                <div className={styles.instructions}>
                    <h4>
                        <FormattedMessage
                            defaultMessage="Thank you for playing{br}Saving Is a Big YES!"
                            description="IGA Contest ended instructions title"
                        />
                    </h4>

                    <p>
                        <FormattedMessage
                            defaultMessage="The contest is now over. It's still time to redeem your coupons at participating IGA and IGA extra stores. You have up to two weeks after the date you obtained them."
                            description="IGA Contest ended instructions 1"
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            defaultMessage="The winner of the $2,000 IGA gift card Grand Prize will be announced on February 23, 2023. Until then, stay by your phone, and good luck!"
                            description="IGA Contest ended instructions 2"
                        />
                    </p>
                </div>
            ) : (
                <div className={styles.instructions}>
                    <p>
                        <FormattedMessage
                            defaultMessage="Answer our “yes” or “no” questions for a chance to win coupons to redeem at participating IGA and IGA extra supermarkets and the Grand Prize of a $2,000 IGA gift card."
                            description="IGA Contest instructions 1"
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            defaultMessage="Whatever the answer, it's all about having fun!"
                            description="IGA Contest instructions 2"
                        />
                    </p>
                </div>
            )}
        </div>
    );
}

IgaContest.propTypes = propTypes;
IgaContest.defaultProps = defaultProps;

export default IgaContest;
